// tslint:disable:no-any
import { Link, PaymentTerm } from '../common';
import { ISalesArea, Jobsite } from '../order-management';
import { IUnitOfMeasure } from '../sales-document-management/models/unit-of-measure';

export interface IJobsiteSalesArea {
  jobsiteSalesAreaId: number;
  salesArea: ISalesArea;
  jobsite: Jobsite;
  paymentTerm: PaymentTerm;
  maneuverable: boolean;
  minimumLot: IAmount;
  maximumLot: IAmount;
  maximumVehicleWeight: IAmount;
  maximumDeliveryVolume?: IAmount;
  maximumVehicleVolume?: IAmount;
  purchaseOrderValidation: boolean;
  plant?: {
    links: Link | Link[] | any;
    plantId: number
  };
  links: Link | Link[] | any;
}

export interface IAmount {
  amount: number;
  unitOfMeasure: IUnitOfMeasure;
}
